export enum PackageCategoryDetailEnum {
    Events = "events",
    EventDetail = "eventDetail",
    CategoryDetail = "categoryDetail",
}